import { render } from "./CarouselButton.vue?vue&type=template&id=306fbdba&scoped=true&ts=true"
import script from "./CarouselButton.vue?vue&type=script&lang=ts"
export * from "./CarouselButton.vue?vue&type=script&lang=ts"

import "./CarouselButton.vue?vue&type=style&index=0&id=306fbdba&lang=scss&scoped=true"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-306fbdba"]])

export default __exports__